import { useEffect, useState } from "react";
import { isPrerendering } from "../utils/isPrerendering";

/** Always false on first paint so prerendered HTML matches hydrate. */
export function usePrefersReducedMotion() {
  const [reduce, setReduce] = useState(false);

  useEffect(() => {
    if (isPrerendering()) return undefined;
    const mq = window.matchMedia("(prefers-reduced-motion: reduce)");
    const sync = () => setReduce(mq.matches);
    sync();
    mq.addEventListener("change", sync);
    return () => mq.removeEventListener("change", sync);
  }, []);

  return reduce;
}
